import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { PriceEditType } from '@/types';
import { PriceOverrideInfo } from '@/experiences/sales-portal/domain/ordering/screens/order-entry/blocs/transformers/order-entry-table-transformers';
import { PriceOverrideInfoDisplay } from '@/experiences/sales-portal/domain/ordering/screens/order-entry/components/order-entry-table/price-override-info';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

interface OrderEntryTableReadOnlyGrossProfitCellProps {
  canSetManualOverrideExpiration?: boolean;
  grossProfitDisplayString: string;
  priceOverrideInfo?: PriceOverrideInfo;
  showPriceOverrideInfo?: boolean;
}

export const OrderEntryTableReadOnlyGrossProfitCell: React.FC<
  OrderEntryTableReadOnlyGrossProfitCellProps
> = ({
  canSetManualOverrideExpiration,
  grossProfitDisplayString,
  priceOverrideInfo,
  showPriceOverrideInfo,
}) => {
  const [styles, theme] = useStyles();
  const hasOverride =
    showPriceOverrideInfo && priceOverrideInfo?.activeOverride !== undefined;

  return (
    <View style={showPriceOverrideInfo ? styles.overrideCell : undefined}>
      <Typography color={theme.sk.color.text.primary} variant="paragraph-md">
        {grossProfitDisplayString}
      </Typography>
      {hasOverride && priceOverrideInfo ? (
        <PriceOverrideInfoDisplay
          defaultValue={priceOverrideInfo.defaultGrossProfitDisplay}
          editedByName={priceOverrideInfo.editedByName}
          expiryDateDisplay={priceOverrideInfo.expiryDateDisplay}
          isInline
          lastValueLabelKey="sales_portal.order_entry.table.temporary_adjustment.last_gross_profit"
          showOverrideIndicator={
            priceOverrideInfo.activeOverride === PriceEditType.GrossProfit
          }
          showTemporaryIndicator={
            !!canSetManualOverrideExpiration &&
            priceOverrideInfo.isTemporaryOverride
          }
        />
      ) : null}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  overrideCell: {
    minHeight: theme.sk.spacing.space3xlarge,
  },
}));
